import { Box, Typography } from '@mui/material'
import React from 'react'
import { UserGroupsDetailTooltip } from './Atom'
import MetricOpportunityDetail from '../../Tooltip/MetricOpportunityDetail'
import UserGroupsDetails from '../../Tooltip/UserGroupDetails'
import { useDispatch } from 'react-redux'
import { setUserGroupsDetails } from '../../../redux/slices/usersSlice'

type Props = {}

const UserTableGroupInfoCell = (props: any) => {

    const { renderedCellValue, cell, row } = props

    const dispatch = useDispatch()

    return (
        <Box>
            <UserGroupsDetailTooltip
                title={renderedCellValue == "all" ? null : renderedCellValue == "0" ? null : <UserGroupsDetails />}
                arrow
                placement="right"
                followCursor={true}
            >

                <Typography
                    color={"#3366D6"}
                    sx={{ textTransform: "capitalize", cursor: "default" }}
                    onMouseEnter={() => {
                        if (renderedCellValue == "all") {
                            dispatch(setUserGroupsDetails(-1))
                        } else if (renderedCellValue == "0") {
                            dispatch(setUserGroupsDetails(-1))
                        } else {
                            dispatch(setUserGroupsDetails(row?.original?.uid))
                        }
                    }}>
                    {renderedCellValue}
                </Typography>

            </UserGroupsDetailTooltip >
        </Box>
    )
}

export default UserTableGroupInfoCell